import { DateFormat, getLocalTimeZone, TimeFormat } from "@tournated-com/ui";
import { useMemo, useState } from "react";

import { DateFormatContext } from "./DateFormatContext";

export const DateFormatContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [dateFormat, setDateFormat] = useState<DateFormat>("european");
  const [timeFormat, setTimeFormat] = useState<TimeFormat>("h24");
  const [timeZone, setTimeZone] = useState<string>(getLocalTimeZone());

  const contextValue = useMemo(
    () => ({
      dateFormat,
      timeFormat,
      timeZone,
      setDateFormat,
      setTimeFormat,
      setTimeZone,
    }),
    [dateFormat, timeFormat, timeZone]
  );

  return <DateFormatContext.Provider value={contextValue}>{children}</DateFormatContext.Provider>;
};
